module.exports = __webpack_public_path__ + "img/scene2-7.96984989.jpg";